import { apiService } from '@/services/APIService';

import significancesService from './significances';

export default {
  significances: significancesService,

  getRegionSettings(params) {
    return apiService.get('/region/settings', params);
  },

  getRatingRegionSettings(params) {
    return apiService.get('/region/rating-settings', params);
  },

  updateRegionSettings(payload) {
    return apiService.put('/region/settings', payload);
  },

  updateRatingRegionSettings(payload) {
    return apiService.put('/region/rating-settings', payload);
  },
};
